// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralTypeCodeService = {};

CollateralTypeCodeService.getCollateralTypeCodeList = function (userInput) {
  return lossClient({
    url: "/CollateralType/search?pageSize=10000&pageIndex=0",
    method: "get",
  });
};

export default CollateralTypeCodeService;
